module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjgiIHZpZXdCb3g9IjAgMCA4IDgiPgogICAgPGcgZmlsbD0iI0ZGRiIgZmlsbC1ydWxlPSJub256ZXJvIiBzdHJva2U9IiNGRkYiPgogICAgICAgIDxwYXRoIGQ9Ik0uNS41aDd2MWgtN3pNMi41IDMuNWg1djFoLTV6TTQuNSA2LjVoM3YxaC0zeiIvPgogICAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/expanded-indicator.svg
// module id = 230
// module chunks = 0